import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import config from 'config';
import PickupTimeline from 'mz-ui-kit/view/PickupTimeline';
import { Container } from './elements';
import {
  getReservation,
  getPickupInstructions,
  getReturnReservation,
} from 'app/sagas/selectors';
import { preprocessTripObject } from 'app/utils/trip';

const mapStateToProps = (state) => {
  const reservation = getReservation(state);
  const returnReservation = getReturnReservation(state);

  const getPreparedData = (reservationObj) => {
    const preparedTrip = preprocessTripObject(reservationObj.trip);
    if (preparedTrip) {
      return {
        hasTickets: preparedTrip.details.scheduledTrip,
        numVehicles: preparedTrip.heading.numVehicles || 1,
        fromIataCode: preparedTrip.routing.fromIataCode,
        waitTime: preparedTrip.details.waitTime,
        fltSupport: !!reservationObj?.trip?.fltSupport,
      };
    }

    return {
      hasTickets: false,
      numVehicles: 1,
      fromIataCode: null,
      waitTime: null,
    };
  };

  return {
    departureInfo: {
      ...getPreparedData(reservation),
      instructions: getPickupInstructions(reservation),
      flightDatetime: reservation.trip?.flightDatetime,
      pickupDatetime: reservation.trip?.pickupDatetime,
    },
    returnInfo: returnReservation && {
      ...getPreparedData(returnReservation),
      instructions: getPickupInstructions(returnReservation),
      flightDatetime: returnReservation.trip?.flightDatetime,
      pickupDatetime: returnReservation.trip?.pickupDatetime,
      isReturn: true,
    },
  };
};

export const builder = (ComposedComponent) => {
  const WrappedComponent = ({
    departureInfo,
    returnInfo,
    showPickupTimeline,
  }) => {
    const doShowTimeline = !!(
      showPickupTimeline && config.SHOW_CP_PICKUP_TIMELINE
    );
    const directions = [departureInfo, returnInfo];

    return (
      <div>
        {directions.map((dir, idx) => {
          if (!dir.instructions && !dir.fromIataCode) return null;
          const showDirTimeline =
            !dir.fltSupport &&
            dir.flightDatetime &&
            dir.pickupDatetime &&
            doShowTimeline &&
            dir.fromIataCode &&
            !dir.hasTickets;

          return (
            <ComposedComponent
              {...dir}
              key={idx}
              showPickupTimeline={showDirTimeline}
              renderContent={() =>
                showDirTimeline && (
                  <Container>
                    <PickupTimeline
                      appearance="inverted"
                      pickupPoint={dir.fromIataCode}
                      landingTime={moment.parseZone(dir.flightDatetime)}
                      driverArrivesTime={moment(dir.pickupDatetime)}
                      freeWaitingMinutes={dir.waitTime}
                    />
                  </Container>
                )
              }
            />
          );
        })}
      </div>
    );
  };

  // TODO: move to Flow types
  // WrappedComponent.propTypes = {
  //   departureInfo: PropTypes.object,
  //   returnInfo: PropTypes.object,
  //   showPickupTimeline: PropTypes.bool,
  // };

  return compose(connect(mapStateToProps))(WrappedComponent);
};

export default builder;
